export default {
  methods: {
    convertTonumberwithCommas(value) {
      let valuewithcomma = value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return valuewithcomma;
    },
  },
};
